// Generated by scripts/build-ui-icons.mjs.
export { SealCheck as default } from "../ui/glyphs-6";
